module.exports = __webpack_public_path__ + "img/d.0e8a6380.jpg";